/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>全部订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" ref="formInline" :model="formInline" class="user-search">
      <el-form-item label="用户UID:" prop="accountId">
        <el-input maxlength="10" type="number" clearable v-model="formInline.accountId" placeholder="输入用户UID"></el-input>
      </el-form-item>
      <el-form-item label="手机号码:" prop="phone">
        <el-input maxlength="13" type="number" clearable v-model="formInline.phone" placeholder="输入手机号码"></el-input>
      </el-form-item>
      <el-form-item label="昵称:" prop="nickName">
        <el-input clearable v-model="formInline.nickName" placeholder="输入昵称"></el-input>
      </el-form-item>
      <el-form-item prop="sex" label="性别">
        <el-select v-model="formInline.sex" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="男" value="1"></el-option>
          <el-option label="女" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="年龄" prop="beginAge">
          <el-input clearable style="width: 80px;" v-model="formInline.beginAge" placeholder="不限"></el-input>&nbsp&nbsp&nbsp-&nbsp&nbsp&nbsp
          <el-form-item label="" prop="endAge">
            <el-input style="width: 80px;" clearable v-model="formInline.endAge" placeholder="不限"></el-input>
          </el-form-item>
      </el-form-item>
      <!-- <el-form-item prop="joinType" label="会员类型:" style="margin-left: -240px;">
        <el-select v-model="formInline.joinType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="活动付费会员" value="1"></el-option>
          <el-option label="活动免费会员" value="2"></el-option>
          <el-option label="活动赠送会员" value="3"></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item prop="orderStatus" label="订单状态">
        <el-select v-model="formInline.orderStatus" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="未付款" value="1"></el-option>
          <el-option label="已付款" value="2"></el-option>
          <el-option label="已退款" value="3"></el-option>
          <el-option label="赠送" value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="teacherId" label="红娘导师:">

        <el-select clearable v-model="formInline.teacherId" placeholder="请选择红娘导师">
          <el-option v-for="item in options123" :key="item.code" :label="item.desc" :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="memberType" label="会员类型">
        <el-select v-model="formInline.memberType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="活动所有会员" value="1"></el-option>
          <el-option label="活动付费会员" value="2"></el-option>
          <el-option label="活动免费会员" value="3"></el-option>
          <el-option label="活动赠送会员" value="4"></el-option>
          <el-option label="咨询所有会员" value="5"></el-option>
          <el-option label="咨询付费会员" value="6"></el-option>
          <el-option label="咨询免费会员" value="7"></el-option>
          <el-option label="精英Club会员" value="8"></el-option>
          <el-option label="线上VIP" value="9"></el-option>

        </el-select>
      </el-form-item>
      <el-form-item label="订单编号:" prop="orderId">
        <el-input maxlength="100" type="number" clearable v-model="formInline.orderId" placeholder="输入用户订单编号"></el-input>
      </el-form-item>
      <el-form-item prop="payType" label="支付类型:">
        <el-select v-model="formInline.payType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="微信支付" value="1"></el-option>
          <el-option label="在线支付" value="2"></el-option>
          <el-option label="抖音支付" value="3"></el-option>


        </el-select>
      </el-form-item>
      <el-form-item prop="activityType" label="订单类型:">
        <el-select v-model="formInline.activityType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="免费活动" value="0"></el-option>
          <el-option label="精选活动" value="1"></el-option>
          <el-option label="精英Club会员赠送" value="2"></el-option>
          <el-option label="精英Club会员付费" value="3"></el-option>
          <el-option label="线上VIP" value="5"></el-option>

        </el-select>
      </el-form-item>
      <el-form-item label="活动ID:" prop="activityId">
        <el-input maxlength="100" type="number" clearable v-model="formInline.activityId" placeholder="输入活动ID"></el-input>
      </el-form-item>
      <el-form-item label="版本号:" prop="version">
        <el-input maxlength="100" clearable v-model="formInline.version" placeholder="输入版本号"></el-input>
      </el-form-item>
      <el-form-item prop="registerType" label="注册类型:">
        <el-select v-model="formInline.registerType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option v-for="item in PlatformTypeOptions" :label="item.label" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item prop="source" label="客户来源">
        <el-select clearable v-model="formInline.source" placeholder="请选择">
          <el-option v-for="(item, index) in forlist" :key="index" :label=item.label :value=item.value></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="isTestAccount" label="测试账号:">
        <el-select v-model="formInline.isTestAccount" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="isVip"  label="vip类型:">
    <el-select v-model="formInline.isVip" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option label="线下超级会员" value="1"></el-option>
      <el-option label="线上VIP" value="2"></el-option>
    </el-select>
  </el-form-item>
      <el-form-item prop="beginRegisterTime" label="注册时间">
        <el-col :span="11">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
            v-model="formInline.beginRegisterTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col :span="11">
          <el-form-item prop="endRegisterTime" label="">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']"  type="datetime" placeholder="选择日期"
              v-model="formInline.endRegisterTime" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item prop="beginPayTime" label="支付时间">
        <el-col :span="11">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
            v-model="formInline.beginPayTime"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col :span="11">
          <el-form-item prop="endPayTime" label="">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss"   default-time="['23:59:59']" type="datetime" placeholder="选择日期"
              v-model="formInline.endPayTime"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item prop="beginApplyTime" label="调起时间">
        <el-col :span="11">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
            v-model="formInline.beginApplyTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col :span="11">
          <el-form-item prop="endApplyTime" label="">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']" type="datetime" placeholder="选择日期"
              v-model="formInline.endApplyTime" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item prop="beginRefundTime" label="退款时间">
        <el-col :span="11">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
            v-model="formInline.beginRefundTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col :span="11">
          <el-form-item prop="endRefundTime" label="">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']" type="datetime" placeholder="选择日期"
              v-model="formInline.endRefundTime" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>





      <el-form-item style="float: right;">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-delete" type="info" @click="resetForm('formInline')">重置</el-button>
        <!-- <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="resetForm('formInline')">重置</el-button> -->
      </el-form-item>
      <el-form-item>
      </el-form-item>

    </el-form>

    <!--列表-->
    <el-table id="educe-table" max-height="600" ref="multipleTable" stripe :data="listData" highlight-current-row v-loading="loading"
      @select-all="selectall" @select="select" border element-loading-text="拼命加载中" style="width: 100%; font-size: 18px;">

      <el-table-column style="font-size: 30px;" align="center" prop="accountId" label="用户UID" width="120">
        <template slot-scope="scope">
          <img style="width:50%;" v-if="scope.row.isVip==1" src="https://test-cos.ynhlminiapp.com/ae6990bf-1687-4fee-b1c4-f579d5caf927.png" alt=""><br>
          <span style="font-size: 28px; font-weight: 600; color: #885DDF">{{ scope.row.accountId }}</span>
          <br><img v-if="scope.row.isJoinVipClub==1" style="width: 90px; height: 30px; margin-top: 10px;" src="https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/a3c71c1d-165d-4688-9db4-0f63541cab90.png" alt="">
          <br><span v-if="scope.row.isMember==1" style="width: 90px; height: 30px; margin-top: 10px; color: red; font-size: 12px" >线上VIP</span>
        </template>

      </el-table-column>


      <el-table-column  align="center" prop="nickName" label="昵称" width="200">
        <template slot-scope="scope">

          <span style="font-size: 24px;">{{ scope.row.nickName }}</span><br>
          <span style="color: #3399FF; font-size: 20px;" v-if="scope.row.nickNameStatus == 1">(待审核)</span><br>
          <span style="color: #34D0B4; font-size: 20px;" v-if="scope.row.nickNameStatus == 2">(审核通过)</span><br>
          <span style="color: #CF1F1F; font-size: 20px;" v-if="scope.row.nickNameStatus == 3">(审核不通过)</span><br>


        </template>

      </el-table-column>
      <el-table-column prop="headIcon" align="center" label="头像" width="180">
        <template slot-scope="scope">
          <el-image style="width: 150px; height: 150px;" :src="scope.row.headIcon"
            :preview-src-list="[scope.row.headIcon]" />
          <span v-if="scope.row.headIconStatus == 1" style="color: #3399FF;">待审核</span>
          <span v-if="scope.row.headIconStatus == 2" style="color: #34D0B4;">{{ scope.row.appearanceScore}}{{ scope.row.appearanceScore?'分':"" }}</span>
          <span v-if="scope.row.headIconStatus == 3" style="color: #CF1F1F;">审核未通过</span>
        </template>
      </el-table-column>
      <el-table-column prop="closeTime" label="基本信息" width="200">
        <template slot-scope="scope">
          <div :style=" scope.row.sex==1? 'color: rgb(52, 208, 180);':'color: #FF1D87;'">年龄:{{ scope.row.age }}岁/{{ scope.row.sex == 1 ? '男' : "女" }}</div>
          <div>学历:{{ scope.row.educationDesc }}</div>
          <!-- <div>身高:{{scope.row.height}}{{scope.row.height?'cm':""}}</div> -->
          <div>月收入:{{ scope.row.monthlyIncomeDesc }}</div>
          <div>婚姻状况:{{ scope.row.maritalStatusDesc }}</div>
          <div>居住地:{{ scope.row.registerAddress }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="phone" label="手机" width="140">
        <template slot-scope="scope">
          <div>{{scope.row.phone,userifom|mobileStr}}</div>
        </template>
      </el-table-column>


      <el-table-column align="center" prop="amount" label="会员类型" width="160">
        <template slot-scope="scope">
           <div v-if="scope.row.joinType==1">付费{{ scope.row.orderType==1?"活动订单":"咨询订单" }}</div>
           <div v-if="scope.row.joinType==2">免费{{ scope.row.orderType==1?"活动订单":"咨询订单" }}</div>
           <div v-if="scope.row.joinType==3">赠送{{ scope.row.orderType==1?"活动订单":"咨询订单" }}</div>
           <div v-if="scope.row.joinType==4">精英Club会员付费</div>
           <div v-if="scope.row.joinType==5">精英Club会员赠送</div>
           <div v-if="scope.row.joinType==6">精英Club会员免费</div>
           <div v-if="scope.row.orderType==6">线上VIP</div>

          <div v-if="scope.row.joinType==1||scope.row.joinType==2||scope.row.joinType==3">{{ scope.row.orderType==1?'活动':"咨询"}}ID:{{ scope.row.activityId }}</div>
          <div v-if="scope.row.orderType==2">{{scope.row.teacherName}}({{ scope.row.teacherRealName}})</div>
          <el-tag v-if="scope.row.cost == 0" type="primary" disable-transitions>免费活动</el-tag>
          <el-tag v-if="scope.row.cost > 0" type="success" disable-transitions>精选活动</el-tag><br>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="amount" label="支付金额" width="100">
        <template slot-scope="scope">
          <div>¥{{ scope.row.amount }}</div>

        </template>

      </el-table-column>
      <el-table-column  align="center"  prop="status" label="账号状态" width="150">
        <template slot-scope="scope">
          <span style="color: #3399FF;" v-if="scope.row.accountStatus==1" >正常</span>
          <span style="color: darkgoldenrod;" v-if="scope.row.accountStatus==2">注销中</span>
          <span  style="color: red;"  v-if="scope.row.accountStatus==3||scope.row.accountStatus==null">已注销</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="refundAmount" label="退款金额" width="100">
        <template slot-scope="scope">
          <div v-if="!scope.row.refundAmount">{{ scope.row.refundAmount }}</div>
          <div v-if="scope.row.refundAmount">¥{{ scope.row.refundAmount }}</div>

        </template>

      </el-table-column>




      <el-table-column align="center" prop="orderStatus" label="订单状态" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.orderStatus == 1">未付款</span>
          <span v-if="scope.row.orderStatus == 2">已付款</span>
          <span style="color: #CF1F1F;" v-if="scope.row.orderStatus == 3">已退款</span>
          <span v-if="scope.row.orderStatus == 4">赠送</span>
          <el-button v-if="scope.row.orderStatus == 3" @click="seeTul(scope.row.refundReason)" type="primary"
            plain>查看原因</el-button>
          <!-- <span>{{ scope.row.title }}</span> -->
        </template>

      </el-table-column>
      <el-table-column align="center" prop="orderId" label="订单编号" width="140">
      </el-table-column>
      <el-table-column align="center" prop="payType" label="支付类型" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.payType == 1">微信支付</span>
          <span v-if="scope.row.payType == 2">在线支付</span>
          <span v-if="scope.row.payType == 3">抖音支付</span>


        </template>

      </el-table-column>
      <el-table-column prop="registerTimeMills" label="注册时间" width="120">
        <template slot-scope="scope">
          <div>{{ scope.row.registerTimeMills | timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="applyTimeMills" label="调起时间" width="120">
        <template slot-scope="scope">
          <div>{{ scope.row.applyTimeMills | timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="payTimeMills" label="支付时间" width="120">
        <template slot-scope="scope">
          <!-- <div >{{ scope.row.payTimeMills | timestampToTime }}</div> -->


          <div v-if="scope.row.payTimeMills">{{ scope.row.payTimeMills | timestampToTime }}</div>
          <div v-if="!scope.row.payTimeMills"></div>
        </template>
      </el-table-column>
      <el-table-column prop="refundTimeMills" label="退款时间" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.refundTimeMills">{{ scope.row.refundTimeMills | timestampToTime }}</div>
          <div v-if="!scope.row.refundTimeMills"></div>

        </template>
      </el-table-column>
      <el-table-column align="center" prop="version" label="版本号" width="100">
      </el-table-column>
      <el-table-column align="center" prop="registerTypeDesc" label="注册类型" width="150">

      </el-table-column>
      <el-table-column align="center" prop="sourceDesc" label="客户来源" width="150">

      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"
      @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <!-- <div style="margin-top: 20px;">
      <el-button @click="selectalls(listData)" type="primary">全选</el-button>
      <el-button @click="imporList" type="success">导出数据</el-button>

    </div> -->
    <el-dialog title="退款说明" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <span>{{ refundReason }}</span>

        <!-- <el-input

  placeholder=""
  v-model="refundReason"
  :disabled="true">

</el-input> -->

      </el-form>

    </el-dialog>

  </div>
</template>

<script>
import Vue from 'vue'
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Axios from 'axios'
import { login } from "../../api"
import { homeData } from '../../request/home'

import {mobileStr}from "../../utils/util"
import Pagination from '../../components/Pagination'
import {PlatformTypeOptions} from "../../enums/userEnum";
export default {
  computed: {
    PlatformTypeOptions() {
      return PlatformTypeOptions
    }
  },
  data() {
    return {
      dialogVisible: false,
      value: "",
      options123: [],
      userifom:"",
      forlist: [],
      options1234123: [],
      aData: new Date(),

      adder: "",
      recommendform: {
        index: "",
        id: ""
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList: [],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',

      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },


      // rules表单验证
      rules: {
        index: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      refundReason: "",
      ssoServer:"",
      formInline: {
        isVip:"",
        teacherId:'',
        id: "",//活动id
        memberType: '',
        source: "",
        accountId: "",//用户id
        // beginAge:"",//开始年龄
        // endAge:"",//结束年龄
        phone: "",//手机号
        nickName: "",//用户昵称
        sex: "",//性别
        beginAge: "",//开始年龄
        endAge: "",//结束年龄
        maritalStatus: "",//婚姻状况
        education: "",//学历
        isTestAccount: "",//是否是测试号
        beginPayTime: "",//报名开始时间
        endPayTime: "",//报名结束时间
        useStatus: "",//状态
        activityId: "",//活动ID
        orderStatus: "",//订单状态
        payType: "",//支付类型
        joinType: "",//会员类型
        registerType: "",//注册类型
        activityType: "",//活动类型
        orderId: "",//订单编号
        version: "",//版本号
        endRegisterTime: "",//结束注册时间
        beginRegisterTime: "",//开始注册时间
        beginApplyTime: "",//开启调起时间
        endApplyTime: "",//结束调起时间
        beginRefundTime: "",//退款开始时间
        endRefundTime: "",//退款结束时间

        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },
      source: [{
        value: '',
        label: '不限'

      }, {
        value: 1,
        label: '网站注册'

      }, {
        value: 2,
        label: '人工录入'

      }, {
        value: 3,
        label: '资源导入'

      }, {
        value: 4,
        label: '相亲活动'

      }, {
        value: 5,
        label: '手机来电'

      }, {
        value: 6,
        label: '表单填写'

      }, {
        value: 7,
        label: '到店咨询'

      }],
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },

  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */

  created() {
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer



    this.formInline.id = this.$route.query.id

    this.value = (new Date()).getTime();
    let tokenId = localStorage.getItem('tokenId');
    this.adder = tokenId



    // this.getdata(this.formInline)
  },
  mounted() {
    this.formLIst()
    this.ongetAddress()
    this.userifom= localStorage.getItem('userifom');

    Axios({
      method: 'get',
      url: this.ssoServer+'/api/teacher/teacherList',
      headers: {
        tokenId: this.adder
      },
    }).then(res => {
      this.options123 = res.data.data

    })
    // this.getAddress()
    // this.getAddresss()


  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    ongetAddress() {
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/source-config/getList',
        headers: {
          tokenId: this.adder
        },
      }).then(res => {
        console.log(res);
        this.forlist = res.data.data
        // this.options123 = res.data.data

      })

    },

    seeTul(item) {
      this.refundReason = item
      this.editFormVisible = true


    },
    adddadad(command) {
      if (command == 'a') {
        console.log('111');
      }
      console.log(command);
    },
    // 推荐
    // getCurrentTime() {
    //     //获取当前时间并打印
    //     var _this = this;
    // let yy = new Date().getFullYear();
    // let mm = new Date().getMonth()+1;
    // let dd = new Date().getDate();
    // let hh = new Date().getHours();
    // let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    // let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    // _this.gettime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss;
    // console.log(_this.gettime)
    // },
    recommend(i, f) {

      if (i == 3) {
        this.recommendform.id = f.id
        this.recommendform.index = 0

        this.$confirm('确定要将该活动推荐取消吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {


          Axios({
            method: 'post',
            url: this.ssoServer+'/api/activity/updateIndex',

            headers: {
              tokenId: this.adder
            },
            data: this.recommendform
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '取消成功'
              })
              this.formLIst()
            }
          })

        }).catch(() => {

        });
        return

      }
      this.recommendform.id = f.id

      this.editFormVisible = true
      this.recommendform.index = ''

    },




    addCogilg() {
      this.$router.push({
        path: "/Eventmanagement/activities",

      })

    },
    selectall(val) {
      // console.log(val);

      let data = []
      // this.importList=''
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      // console.log(val);
    },


    // getAddress() {

    //   Axios({
    //     method: 'get',
    //     url: this.ssoServer+'/api/common/getAddressList1',

    //     headers: {
    //       tokenId: this.adder
    //     }
    //   }).then(res => {
    //     if (res.data.code == 999) {
    //       setTimeout(() => {
    //         localStorage.removeItem('tokenId')

    //         this.$store.commit('logout', 'false')
    //         this.$router.push({ path: '/login' })
    //         this.$message({
    //           type: 'success',
    //           message: '登录过期,请重新登录'
    //         })
    //       }, 1000)
    //     }
    //     // console.log("getAddressList", res.data.data);
    //     this.options123 = res.data.data

    //   })
    // },


    change1(e) {
      console.log("change1", e);
      if (e.length === 1) {
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if (e.length === 2) {
        this.formInline.registerAddress = e[1];
      }
    },

    selectalls(rows) {

      if (rows) {
        let data = []
        rows.forEach((item) => {
          data.push(item.id)
          this.importList = data
          console.log(this.importList);

        })
        rows.forEach(row => {

          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        console.log('1212112');
        this.importList = []

        this.$refs.multipleTable.clearSelection();//清除全选
      }


    },

    onChange(e) {

      this.formInline.activityAddressCode = e[1]
      // console.log( this.formInline.registerAddress);


    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出数据
    imporList() {
      if (this.importList.length == 0) {

        this.$message({
          type: 'warning',
          message: '请选择要导出的数据'
        })
        return

      } else {
        Axios({
          method: 'post',

          url: this.ssoServer+'/api/platform-account/exportExcel',
          headers: {
            tokenId: this.adder
          },
          data: {
            accountIds: this.importList,
            searchType: 1
          },
          responseType: 'blob'
        }).then(res => {
          const link = document.createElement('a') // 创建a标签
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
          link.href = window.URL.createObjectURL(blob)
          const filename = res.headers['content-disposition'].split('filename=')[1]
          link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
          link.click()
          window.URL.revokeObjectURL(link.href)
        })


      }




    },
    select(selection, row) {

      let data = []
      // this.importList=''
      selection.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
      //  this.formInline =''
      this.$refs[formInline].resetFields();
    },


    formLIst() {

      // let accountListReqVO= this.formInline
      Axios({
        method: 'get',

        url: this.ssoServer+'/api/orders/getOrderList',
        headers: {
          tokenId: this.adder
        },
        params: this.formInline


      }).then(res => {
        console.log(res);
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        } else if (res.data.code == 500) {
          this.$message({
            type: 'warning',
            message: res.data.message
          })
        }
        this.listData = res.data.data.list
        this.pageparm.currentPage = this.formInline.current
        this.pageparm.pageSize = this.formInline.size
        this.pageparm.total = res.data.data.total
        // console.log(res);
      })

    },
    formatData(row, column, cellValue, index) {

      //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
      //最终返回 s 就可以了
      var s = new Date(cellValue).toLocaleString();
      return s;
    },
    handleSizeChange(e) {
      // reru console.log(e.pageSize);
      this.formInline.size = e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
      // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
      this.formInline.current = 1
      // console.log(this.formInline);
      this.formLIst()
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          Axios({
            method: 'post',
            url: this.ssoServer+'/api/activity/updateIndex',

            headers: {
              tokenId: this.adder
            },
            data: this.recommendform
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '推荐成功'
              })
              this.editFormVisible = false
              this.formLIst()

            } else {
              this.$message({
                type: 'warning',
                message: res.data.message
              })
              return

            }


          })
        }
      })
    },
    // async logins() {
    //     // 网络请求
    //     let data = await login('1111111');
    //     // let token = data.token;
    //     // 本地  vuex
    //     // this.$store.commit('LOGIN_IN',token);
    //     this.$router.replace("/")
    // },

    // 删除公司

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/Ordermanagement/Allmanagement.vue